/**
 * 69.59 step 1, the helicopter's flight (DECISIONS 270 (4), the owner: "Then I also probably want to introduce the
 * helicopter."; lane H's sheet, design_sheets/helicopter.html, its leans: transport first, a third craft kind in 69.17's one
 * flight model, living low at nap height, a soft hull, the tail rotor as a part; GameConfig.helicopters): a side's helicopter is
 * a dropship flight of the `heli` craft — called like a dropship to bring those waiting in, `seats` of them, flown at
 * `speedPeople` a second and `napPeople` over the ground under it (it follows the ground, the dips and the rises, where a
 * dropship holds its cruise level), round the cover its side knows of as a dropship's; it lands, lets them out, lifts and
 * goes home. Its hull is soft (the damage table's `soft` row: rounds wear it), `health` of it; its parts are the cockpit, the
 * two engines and the tail rotor (core/shipBody.ts HELI_BODY). Look C's numbers (the armed utility: a cabin of eight, cruise
 * ~33 people a second). 69.59 step 3 (DECISIONS 286 (3), (4)): its `crew`, two pilots and two door gunners (the gunners man
 * the door guns, HELI_GUNS; the crew is the ship's, never riders: no seat of the eight); `irSuppressor`, the share of a seeker's
 * lock reach left on one flying with its IR suppressors fitted (an attachment a call carries: the plume mixed and turned away).
 * Proposals.
 */
export const HELI = { seats: 8, speedPeople: 33, napPeople: 8, health: 250, crew: { pilots: 2, doorGunners: 2 }, irSuppressor: 0.7 };
/**
 * 69.59 step 2, the helicopter's pickup (69.18's for a helicopter; the hot rescue's lift to come, 69.62): it sets out from, and
 * comes back down to, a clear spot `homePeople` out from the side's base toward its landing (off the wave ship's pad), its
 * riders out of its doors there. Its wait and its boarding reach are the wave ship's (SHIP_PICKUP). A proposal.
 */
export const HELI_PICKUP = { homePeople: 30 };
/**
 * 69.74 step 1 (DECISIONS 302, the owner: "I couldn't call helicopters"): a person's lift of a squad (Go ▸ Fly there) — refused
 * when the drop is within `nearPeople` of the squad (a walk). A proposal.
 */
export const HELI_LIFT = { nearPeople: 30 };
/**
 * 69.74 step 2 (DECISIONS 302, the owner's "Parked at a helipad"; GameConfig.helipad): a side's helipad — a slab behind its base,
 * `behindPeople` behind the HQ away from the enemy's base and `asidePeople` across (clear of the towed guns' line), its spots a
 * row across it `spotPeople` apart (the helicopter's rotor, ~8 people, and a walk), `spots` of them (the Lab's most), its deck
 * `halfZPeople` deep, its slab's top `deckPeople` up; `health` a structure's. A helicopter back on its spot turns round —
 * refuelled and rearmed — for `turnaroundSeconds` before it flies again. A proposal.
 */
export const HELI_PAD = { spots: 2, spotPeople: 10, halfZPeople: 6, deckPeople: 0.1, behindPeople: 34, asidePeople: 22, health: 300, turnaroundSeconds: 45 } as const;
/**
 * 69.59 step 3, the helicopter's weapons (DECISIONS 286 (2), the owner: "sure"; the coordinator's reading: "door .50s and rocket
 * pods, the door guns firing on their own as the gunship's do"; core/heliGuns.ts, through the gunship's weapon code): the door
 * gunners' .50s (MOUNTED_GUNS.hmg's round), each out of its own door at the nearest enemy in its cone, in bursts, while it
 * flies in, sits down and flies out — what it engages within `reachPeople` of the ground under it and `slantPeople` of the gun,
 * in sight, none of its side within GUNSHIP.friendlyPeople of it; and the stub wings' pods (the gunship's pods' rockets), a
 * pair at a time at what lies ahead of its nose on its run in. Where they leave its frame (people: +x its left, y up from its
 * wheels, z its front; look C's mounts ÷ 1.8, outside the hull's hit shape, core/shipBody.ts HELI_BODY): the door guns' muzzles
 * (left, right), the pods' fronts (left, right). Cones (radians): a door gun's bearing either side of its door's outward
 * normal and its depression (half a radian up — a pintle gun firing uphill from the ground — to steeply down); the pods' bearing either side of its heading and depression.
 * Counts: `doorRounds` a gun (a can of 500), `podRounds` (7 a pod). A weapon that looks and finds nothing looks again
 * `scanSeconds` on (its gunner's scan; the search's cost off the ticks between). Proposals.
 */
export const HELI_GUNS = {
  reachPeople: 60,
  slantPeople: 70,
  muzzles: {
    door: [[1.2, 0.95, 0.14], [-1.2, 0.95, 0.14]] as const,
    pods: [[1.47, 1.36, 0.6], [-1.47, 1.36, 0.6]] as const,
  },
  cones: { door: { bearing: 1.2, depression: [-0.5, 1.45] as const }, pods: { bearing: 0.45, depression: [0.02, 0.8] as const } },
  doorBurst: 8,
  doorRest: 1.0,
  doorRounds: 500,
  podRounds: 14,
  scanSeconds: 0.25,
} as const;
